import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterModule } from './layouts/footer/footer.module';
import { NavbarModule } from './layouts/navbar/navbar.module';
import { MainModule } from './layouts/main/main.module';
import { SharedModule } from './shared/shared.module';
import { Bitrix24Component } from './pages/bitrix24/bitrix24.component';

@NgModule({
  declarations: [
    AppComponent,
    Bitrix24Component,
  ],
  imports: [
    FooterModule,
    NavbarModule,
    MainModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule
  ],
  exports: [
    AppRoutingModule,
    SharedModule,
    Bitrix24Component],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
